module.exports = __webpack_public_path__ + "img/3.47bd3494.jpg";